import { render, staticRenderFns } from "./_Confirm.vue?vue&type=template&id=6f25c33d&scoped=true&"
import script from "./_Confirm.vue?vue&type=script&lang=js&"
export * from "./_Confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f25c33d",
  null
  
)

export default component.exports